import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { notificar } from '../utils/notify';
import '../styles/Contabilidade.css';

const TextoLivre = () => {
  const navigate = useNavigate();
  const [empresas, setEmpresas] = useState([]);
  const [operadores, setOperadores] = useState([]);
  const [textosLivres, setTextosLivres] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [excluindo, setExcluindo] = useState(null);
  const [mensagem, setMensagem] = useState('');

  useEffect(() => { notificar(mensagem); }, [mensagem]);

  // Estados do formulário
  const [operadorSelecionado, setOperadorSelecionado] = useState('');
  const [empresaSelecionada, setEmpresaSelecionada] = useState('');
  const [textoDigitado, setTextoDigitado] = useState('');
  const [filtroTextos, setFiltroTextos] = useState('');

  // Modal de confirmação
  const [mostrarModal, setMostrarModal] = useState(false);
  const [textoParaExcluir, setTextoParaExcluir] = useState(null);

  // Carregar empresas
  const carregarEmpresas = () => {
    const accessToken = localStorage.getItem('access');
    
    axios
      .get(`${process.env.REACT_APP_API_BASE}/api/empresas-contabil/`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      })
      .then((res) => {
        const empresasCarregadas = res.data.empresas || [];
        setEmpresas(empresasCarregadas.sort((a, b) => a.empresa.localeCompare(b.empresa)));
        
        // Extrair operadores únicos das empresas
        const operadoresUnicos = [...new Set(
          empresasCarregadas
            .map(emp => emp.operador)
            .filter(op => op && op.trim() !== '')
        )].sort();
        
        setOperadores(operadoresUnicos);
      })
      .catch((error) => {
        setMensagem('Erro ao carregar empresas: ' + (error.response?.data?.erro || error.message));
      });
  };

  // Carregar textos livres
  const carregarTextosLivres = () => {
    setCarregando(true);
    const accessToken = localStorage.getItem('access');
    
    axios
      .get(`${process.env.REACT_APP_API_BASE}/api/textos-livres-contabil/`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      })
      .then((res) => {
        setTextosLivres(res.data.textos || []);
        setCarregando(false);
      })
      .catch((error) => {
        setMensagem('Erro ao carregar textos: ' + (error.response?.data?.erro || error.message));
        setCarregando(false);
      });
  };

  // Filtrar empresas por operador
  const empresasFiltradas = operadorSelecionado
    ? empresas.filter(emp => emp.operador === operadorSelecionado)
    : empresas;

  // Limpar seleção de empresa quando mudar operador
  const handleOperadorChange = (e) => {
    setOperadorSelecionado(e.target.value);
    setEmpresaSelecionada(''); // Limpa a empresa selecionada
  };

  // Salvar novo texto
  const salvarTexto = () => {
    if (!empresaSelecionada || !textoDigitado.trim()) {
      setMensagem('Por favor, selecione uma empresa e digite o texto.');
      return;
    }

    setSalvando(true);
    const accessToken = localStorage.getItem('access');
    
    const empresaInfo = empresas.find(emp => emp.numero_dominio.toString() === empresaSelecionada);
    
    axios
      .post(
        `${process.env.REACT_APP_API_BASE}/api/salvar-texto-livre-contabil/`,
        {
          numero_dominio: empresaSelecionada,
          empresa: empresaInfo?.empresa || '',
          texto: textoDigitado.trim()
        },
        {
          headers: { Authorization: `Bearer ${accessToken}` }
        }
      )
      .then(() => {
        setMensagem('Texto salvo com sucesso!');
        setTextoDigitado('');
        setEmpresaSelecionada('');
        setOperadorSelecionado('');
        carregarTextosLivres();
        setSalvando(false);
      })
      .catch((error) => {
        setMensagem('Erro ao salvar texto: ' + (error.response?.data?.erro || error.message));
        setSalvando(false);
      });
  };

  // Abrir modal de confirmação
  const confirmarExclusao = (texto) => {
    setTextoParaExcluir(texto);
    setMostrarModal(true);
  };

  // Excluir texto
  const excluirTexto = () => {
    if (!textoParaExcluir) return;

    setExcluindo(textoParaExcluir.id);
    const accessToken = localStorage.getItem('access');
    
    axios
      .delete(
        `${process.env.REACT_APP_API_BASE}/api/excluir-texto-livre-contabil/${textoParaExcluir.id}/`,
        {
          headers: { Authorization: `Bearer ${accessToken}` }
        }
      )
      .then(() => {
        setMensagem('Texto excluído com sucesso!');
        carregarTextosLivres();
        setMostrarModal(false);
        setTextoParaExcluir(null);
        setExcluindo(null);
      })
      .catch((error) => {
        setMensagem('Erro ao excluir texto: ' + (error.response?.data?.erro || error.message));
        setExcluindo(null);
        setMostrarModal(false);
      });
  };

  // Filtrar textos
  const textosFiltrados = textosLivres.filter((item) => {
    if (!filtroTextos) return true;
    
    const filtroLower = filtroTextos.toLowerCase();
    return (
      item.empresa.toLowerCase().includes(filtroLower) ||
      item.numero_dominio.toString().includes(filtroLower) ||
      item.texto.toLowerCase().includes(filtroLower)
    );
  });

  useEffect(() => {
    carregarEmpresas();
    carregarTextosLivres();
  }, []);

  return (
    <div className="contabilidade-page">
      <div className="container mt-5 shadow p-4 rounded bg-white">
        {/* Cabeçalho */}
        <div className="header-wrapper d-flex justify-content-between align-items-center mb-4">
          <div className="d-flex align-items-center">
            <i className="fas fa-edit header-icon me-2"></i>
            <h2 className="titulo-pagina m-0">Textos Livres - Contábil</h2>
          </div>
          <button 
            className="btn btn-outline-secondary"
            onClick={() => navigate('/contabilidade')}
          >
            <i className="fas fa-arrow-left me-2"></i>
            Voltar
          </button>
        </div>

        {/* Mensagens agora são exibidas como toast (react-toastify) */}

        {/* Formulário para criar novo texto */}
        <div className="card mb-4">
          <div className="card-header bg-primary text-white">
            <h5 className="mb-0">
              <i className="fas fa-plus-circle me-2"></i>
              Adicionar Novo Texto
            </h5>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-3 mb-3">
                <label className="form-label fw-bold">
                  <i className="fas fa-user me-1"></i>
                  Operador:
                </label>
                <select
                  className="form-select"
                  value={operadorSelecionado}
                  onChange={handleOperadorChange}
                  disabled={salvando}
                >
                  <option value="">Todos os operadores...</option>
                  {operadores.map((operador) => (
                    <option key={operador} value={operador}>
                      {operador}
                    </option>
                  ))}
                </select>
                {operadorSelecionado && (
                  <small className="text-muted">
                    <i className="fas fa-filter me-1"></i>
                    {empresasFiltradas.length} empresa(s)
                  </small>
                )}
              </div>
              <div className="col-md-5 mb-3">
                <label className="form-label fw-bold">
                  <i className="fas fa-building me-1"></i>
                  Empresa:
                </label>
                <select
                  className="form-select"
                  value={empresaSelecionada}
                  onChange={(e) => setEmpresaSelecionada(e.target.value)}
                  disabled={salvando}
                >
                  <option value="">
                    {operadorSelecionado 
                      ? `Selecione uma empresa do operador ${operadorSelecionado}...` 
                      : 'Selecione uma empresa...'}
                  </option>
                  {empresasFiltradas.map((empresa) => (
                    <option key={empresa.numero_dominio} value={empresa.numero_dominio}>
                      {empresa.numero_dominio} - {empresa.empresa}
                    </option>
                  ))}
                </select>
                {!operadorSelecionado && empresas.length > 20 && (
                  <small className="text-info">
                    <i className="fas fa-lightbulb me-1"></i>
                    Dica: Selecione um operador para filtrar as empresas
                  </small>
                )}
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label fw-bold">
                  <i className="fas fa-align-left me-1"></i>
                  Texto:
                </label>
                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Digite aqui suas observações sobre a empresa..."
                  value={textoDigitado}
                  onChange={(e) => setTextoDigitado(e.target.value)}
                  disabled={salvando}
                  maxLength="1000"
                />
                <small className="text-muted">
                  {textoDigitado.length}/1000 caracteres
                </small>
              </div>
            </div>
            <div className="text-end">
              <button
                className="btn btn-primary"
                onClick={salvarTexto}
                disabled={!empresaSelecionada || !textoDigitado.trim() || salvando}
              >
                {salvando ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Salvando...
                  </>
                ) : (
                  <>
                    <i className="fas fa-save me-2"></i>
                    Salvar Texto
                  </>
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Lista de textos existentes */}
        <div className="card">
          <div className="card-header bg-info text-white d-flex justify-content-between align-items-center">
            <h5 className="mb-0">
              <i className="fas fa-list me-2"></i>
              Textos Cadastrados
            </h5>
            <span className="badge bg-light text-dark">
              {textosFiltrados.length} registro(s)
            </span>
          </div>
          <div className="card-body">
            {/* Campo de filtro */}
            <div className="mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Filtrar por empresa, domínio ou texto..."
                value={filtroTextos}
                onChange={(e) => setFiltroTextos(e.target.value)}
              />
            </div>

            {carregando ? (
              <div className="text-center py-4">
                <div className="spinner-border" role="status"></div>
                <p className="mt-2">Carregando textos...</p>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-striped table-hover">
                  <thead className="table-dark">
                    <tr>
                      <th style={{ width: '150px' }}>Data/Hora</th>
                      <th style={{ width: '120px' }}>Nº Domínio</th>
                      <th style={{ width: '250px' }}>Empresa</th>
                      <th>Texto</th>
                      <th style={{ width: '100px' }} className="text-center">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {textosFiltrados.length > 0 ? (
                      textosFiltrados.map((item) => (
                        <tr key={item.id}>
                          <td className="text-nowrap">{item.data_hoje}</td>
                          <td className="text-center">{item.numero_dominio}</td>
                          <td className="fw-semibold">{item.empresa}</td>
                          <td>
                            <div style={{ maxHeight: '100px', overflowY: 'auto' }}>
                              {item.texto}
                            </div>
                          </td>
                          <td className="text-center">
                            <button
                              className="btn btn-danger btn-sm"
                              onClick={() => confirmarExclusao(item)}
                              disabled={excluindo === item.id}
                              title="Excluir texto"
                            >
                              {excluindo === item.id ? (
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                              ) : (
                                <i className="fas fa-trash-alt"></i>
                              )}
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center text-muted py-4">
                          {filtroTextos ? 'Nenhum texto encontrado com esse filtro.' : 'Nenhum texto cadastrado ainda.'}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Modal de confirmação */}
      {mostrarModal && (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header" style={{ backgroundColor: '#ffffff', borderBottom: '1px solid #e9ecef' }}>
                <h5 className="modal-title mb-0 fw-bold" style={{ color: '#212529' }}>
                  <i className="fas fa-exclamation-triangle me-2"></i>
                  Confirmar Exclusão
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setMostrarModal(false);
                    setTextoParaExcluir(null);
                  }}
                  disabled={excluindo}
                ></button>
              </div>
              <div className="modal-body">
                <p className="mb-2">Tem certeza que deseja excluir este texto?</p>
                <div className="alert alert-warning">
                  <strong>Empresa:</strong> {textoParaExcluir?.empresa}<br />
                  <strong>Texto:</strong> {textoParaExcluir?.texto.substring(0, 100)}
                  {textoParaExcluir?.texto.length > 100 && '...'}
                </div>
                <p className="text-danger small mb-0">
                  <i className="fas fa-info-circle me-1"></i>
                  Esta ação não poderá ser desfeita.
                </p>
              </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={() => {
                    setMostrarModal(false);
                    setTextoParaExcluir(null);
                  }}
                  disabled={excluindo}
                >
                  Cancelar
                </button>
                <button 
                  type="button" 
                  className="btn btn-danger" 
                  onClick={excluirTexto}
                  disabled={excluindo}
                >
                  {excluindo ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Excluindo...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-trash-alt me-2"></i>
                      Excluir
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TextoLivre;